import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogoMark } from "../components/Logo";
import { useApp } from "../context/AppContext";
import { useToast } from "../hooks/use-toast";
import { api, setAdminToken, setClientToken } from "../services/api";

const inputCls = "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-orange focus:ring-2 focus:ring-orange/20 outline-none text-sm bg-white";

const Connexion = () => {
  const { t } = useApp();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });

  const forgot = async () => {
    const email = (form.email || "").trim();
    if (!email) { toast({ title: "E-mail requis", description: "Saisissez votre e-mail puis cliquez à nouveau sur « Code oublié ? »." }); return; }
    try { await api.forgotCode(email); } catch { /* ignore */ }
    toast({ title: "Ssuq", description: "Si un compte validé existe pour cet e-mail, votre code vient d'être renvoyé." });
  };

  const submit = async (e) => {
    e.preventDefault();
    // Accès administrateur caché : si le mot de passe correspond au code admin
    try {
      const adm = await api.adminLogin(form.password);
      if (adm.ok && adm.token) { setAdminToken(adm.token); sessionStorage.setItem("ssuq_admin", "1"); navigate("/admin"); return; }
    } catch { /* ignore */ }
    // Connexion client pro : e-mail + code client reçu par mail
    try {
      const res = await api.clientLogin(form.email, form.password);
      if (res.ok) {
        sessionStorage.setItem("ssuq_client", JSON.stringify(res.client));
        if (res.token) setClientToken(res.token);
        toast({ title: "Ssuq ✔", description: t("login_ok") });
        // Rechargement complet pour récupérer le catalogue avec les prix (jeton client)
        setTimeout(() => { window.location.assign("/catalogue"); }, 600);
        return;
      }
    } catch { /* ignore */ }
    toast({ title: "Ssuq", description: "Identifiants incorrects ou compte non encore validé." });
  };

  return (
    <div className="pt-28 pb-24 min-h-screen bg-cream flex items-start">
      <div className="max-w-md w-full mx-auto px-5">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-10">
          <div className="flex flex-col items-center text-center">
            <LogoMark size={52} />
            <h1 className="font-display font-black text-3xl text-navy mt-4">{t("login_title")}</h1>
            <p className="text-gray-500 text-sm mt-2">{t("login_sub")}</p>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block"><span className="font-display font-semibold text-sm text-navy">{t("f_email")}</span>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={`${inputCls} mt-1.5`} /></label>
            <label className="block"><span className="font-display font-semibold text-sm text-navy">{t("login_code")}</span>
              <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={`${inputCls} mt-1.5`} /></label>
            <button type="submit" className="w-full btn-navy font-display font-semibold rounded-full py-3.5">{t("login_btn")}</button>
          </form>
          <button type="button" onClick={forgot} data-testid="forgot-code-btn" className="w-full text-center text-sm text-navy hover:text-orange font-semibold mt-4">Code oublié ? Recevoir mon code par e-mail</button>
          <p className="text-center text-sm text-gray-500 mt-4">{t("no_account")} <Link to="/inscription" className="text-orange font-semibold hover:underline">{t("create_account")}</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Connexion;
